import { Link } from "react-router-dom";
import { MapPin, Mail, Lock, FileText } from "lucide-react";
import Logo from "@/components/Logo";
import { waLink } from "@/lib/api";
import { MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-ink text-white mt-24">
      <div className="border-b border-white/10 bg-white/5">
        <div className="container-site py-8 flex flex-col md:flex-row items-start md:items-center gap-4" data-testid="footer-otto-per-mille">
          <span className="shrink-0 rounded-full bg-brand-aqua text-white font-extrabold px-4 py-2 text-lg">8×1000</span>
          <p className="text-slate-300 text-base leading-relaxed">
            Destinando il tuo 8 per mille all'Associazione Vittime del Debito non spendi nulla in
            più, ma ci permetti di aiutare gratuitamente più persone in difficoltà.{" "}
            <strong className="text-white">Codice fiscale: 14869890963.</strong> Basta una firma
            nella tua dichiarazione dei redditi.{" "}
            <Link to="/otto-per-mille" className="text-brand-aqua font-bold hover:text-white transition-colors" data-testid="footer-otto-per-mille-link">
              Scopri come →
            </Link>
          </p>
        </div>
      </div>
      <div className="container-site py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="mb-5">
            <Logo dark />
          </div>
          <p className="text-slate-300 text-base leading-relaxed">
            Informiamo gratuitamente i debitori sui loro diritti e accompagniamo le persone in
            difficoltà verso una nuova partenza. Nei casi più gravi, anche con supporto psicologico
            professionale.
          </p>
        </div>

        <div>
          <h3 className="font-bold text-lg mb-4 text-brand-aqua">Le nostre sedi</h3>
          <ul className="space-y-4 text-slate-300 text-base">
            <li className="flex gap-3">
              <MapPin className="w-5 h-5 mt-1 shrink-0 text-brand-aqua" />
              <span>
                <strong className="text-white">Sede legale — Milano</strong>
                <br />
                Via Pordenone 13, 20132 Milano (MI)
              </span>
            </li>
            <li className="flex gap-3">
              <MapPin className="w-5 h-5 mt-1 shrink-0 text-brand-aqua" />
              <span>
                <strong className="text-white">Sede operativa — Gallarate</strong>
                <br />
                Via Scipione Ronchetti 8, 21013 Gallarate (VA)
              </span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-bold text-lg mb-4 text-brand-aqua">Contatti</h3>
          <ul className="space-y-3 text-slate-300 text-base">
            <li>
              <a
                href="mailto:info@associazionevittimedeldebito.it"
                className="flex items-center gap-3 hover:text-white transition-colors"
                data-testid="footer-email-link"
              >
                <Mail className="w-5 h-5 text-brand-aqua" />
                info@associazionevittimedeldebito.it
              </a>
            </li>
            <li>
              <a
                href={waLink("Buongiorno, vorrei essere contattato dall'Associazione.")}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 hover:text-white transition-colors"
                data-testid="footer-whatsapp-link"
              >
                <MessageCircle className="w-5 h-5 text-brand-aqua" />
                Scrivici su WhatsApp
              </a>
            </li>
            <li>
              <Link
                to="/admin"
                className="flex items-center gap-3 hover:text-white transition-colors"
                data-testid="footer-admin-link"
              >
                <Lock className="w-5 h-5 text-brand-aqua" />
                Area riservata
              </Link>
            </li>
            <li>
              <Link
                to="/privacy"
                className="flex items-center gap-3 hover:text-white transition-colors"
                data-testid="footer-privacy-link"
              >
                <FileText className="w-5 h-5 text-brand-aqua" />
                Informativa privacy
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-site py-6 text-sm text-slate-400 flex flex-col sm:flex-row gap-2 justify-between">
          <span>© 2026 Associazione Vittime del Debito — C.F. / P.IVA 14869890963 — Assistenza sempre gratuita</span>
          <span>Le informazioni del sito non sostituiscono la consulenza legale personalizzata.</span>
        </div>
      </div>
    </footer>
  );
}
